export default "__VITE_ASSET__1CS9qMOu__"